import * as React from 'react';

import {
    Props,
} from 'one-ui';
import {
    useDispatch,
    useSelector,
  } from 'react-redux';
import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';
import defaultGearIcon from 'one-ui-graphics/svg/gear.svg';
import {
    buildGearActionsMenu,
} from 'one-ui-gear/src/actions';
import {
    useCtx,
} from 'one-ui-provider';

import {
    ScreenPopFrom,
    ScreenpopModel
} from 'one-state-screenpop/src/model';

import {
    setAction as screenpopAction
} from 'one-state-screenpop/src/actions';
import {
    ScreenpopModel as ReceiveCommModel
} from 'one-state-receive-communication/src/model';
  
import {
    setAction as ReceiveCommAction
} from 'one-state-receive-communication/src/actions';

import { Image_URL } from 'one-ui-image';

export interface CardBillingOutstandingProps extends Props {
    title?: string;
    outstandingaccountdetails: JSX.Element;
    outstandingaccountbalance: JSX.Element;
    selectedRowIndex: number;
}

export const CardBillingOutstanding = ({
    outstandingaccountdetails,
    outstandingaccountbalance,
    title,
}: CardBillingOutstandingProps): JSX.Element => {
    const { agentId, settings, resolver, static_resource_url } = useCtx();
    const { compatible, screenpop_config,epicendpoints,uisettings } = settings;
    const {searchID} = epicendpoints;
    const { location, pendingbills, nomatchid, event } = screenpop_config;
    const { contact_center_type, screenpop_type,useridtype,sso,lookuptype } = compatible;
    const {billingtype} = uisettings;
    const patients = useSelector((state: any) => (state.subjectstore));
    const choosecaller = useSelector((state: any) => (state.choosecaller));
    const epicuserid = useSelector((state:any) => (state.epicuserid));
    const billingdetails = useSelector((state: any) => (state.billingdetails));
    const dispatch = useDispatch();
    const handleScreenPop = (activityId: string) => {
        const patientContactNumber = patients?.selected?.contact;
        let formattedPhoneNumber = patientContactNumber?.replace(/-/g,'');
        if(screenpop_type === 'snap_adapter'){
            let agentIdValue = agentId;
            if (contact_center_type && contact_center_type === 'five9') {
                //This is for Five9
                agentIdValue = sessionStorage.getItem("agentName");
            }
            const patientid = patients?.selected?.id
            const sobject: ScreenpopModel = {
                activityId,
                patientId: patientid ? patientid : nomatchid,
                eventType: event,
                location,
                agentId: agentIdValue,
                from: ScreenPopFrom.BILLING_TAB
            }
            dispatch(screenpopAction(sobject));
        }else{
            let agentIdValue = agentId;
            if (contact_center_type && contact_center_type === 'five9') {
              //This is for Five9
              agentIdValue = epicuserid?.agentuserid;
            }
            else if( sso === false) {
                agentIdValue = epicuserid?.agentuserid
            }
            const patientid = patients?.selected?.id
            if(screenpop_type === "receive_communication02") {
                const sobject: ReceiveCommModel = {
                    context: activityId,
                    patientId: billingdetails.selected.AccountId ? billingdetails.selected.AccountId : "",
                    agentId: agentIdValue,
                    lookuptype: lookuptype,
                    useridtype: useridtype,
                    callId: choosecaller.dnis,
                    contactType: 'Incoming',
                    communicationType: 'Phone',
                    phoneNumber: formattedPhoneNumber ? formattedPhoneNumber : choosecaller?.number,
                    type: billingtype.lookupidtype ? billingtype.lookupidtype : "",
                    from: ScreenPopFrom.BILLING_TAB
                  }
                  dispatch(ReceiveCommAction(sobject));
            }
            else if(screenpop_type === "receive_communication") {
                const sobject: ReceiveCommModel = {
                    context: activityId,
                    patientId: patientid ? patientid : "",
                    agentId: agentIdValue,
                    lookuptype: lookuptype,
                    useridtype: useridtype,
                    callId: choosecaller.dnis,
                    contactType: 'Incoming',
                    communicationType: 'Phone',
                    phoneNumber: formattedPhoneNumber ? formattedPhoneNumber : choosecaller?.number,
                    type: patientid ? searchID : "",
                    from: ScreenPopFrom.BILLING_TAB
                  }
                  dispatch(ReceiveCommAction(sobject));
            }
        }
    }

    let gearJson = [];
    let idincr = "1";
    gearJson.push({
      id: idincr,
      label: 'Show Guarantor Search in Epic',
      onClick: () => {
        handleScreenPop(pendingbills);
      }
    });

    return (
        <div className="outstand-account__box">
            <h3 className="font-medium text-base mb-10">{title}</h3>
            <div className="outstand-account__main">
                <div className="outstand-account__main-list">
                    <table className="outstand-account__list">
                        {outstandingaccountdetails}
                    </table>
                </div>
                <div className="outstand-account__main-balance">
                    <table className="outstand-account__balance">
                        {outstandingaccountbalance}
                    </table>
                </div>
                <div style={{ marginTop: '-34px', position: 'absolute', right: '20px' }}>
                    <Dropdown overlay={
                        buildGearActionsMenu(
                            gearJson,
                        )
                    } placement='bottomRight'>
                        <Button size='small' className="ant-btn--gear">
                            <img
                                src={Image_URL(resolver(defaultGearIcon), `${static_resource_url}gear.1a9c9834.svg`)}
                                width='12'
                                height='12'
                                draggable="false"
                            />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        </div>
    );
}
